import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth endpoints
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
};

// Facility endpoints
export const facilityAPI = {
  getAll: () => api.get('/facilities'),
  getOne: (id) => api.get(`/facilities/${id}`),
  create: (data) => api.post('/facilities', data),
  update: (id, data) => api.put(`/facilities/${id}`, data),
  delete: (id) => api.delete(`/facilities/${id}`),
};

// Document endpoints
export const documentAPI = {
  getAll: (facilityId) => api.get('/documents', { params: { facilityId } }),
  upload: (formData) => api.post('/documents/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  getAnalysis: (id) => api.get(`/documents/${id}/analysis`),
  delete: (id) => api.delete(`/documents/${id}`),
};

// Task endpoints
export const taskAPI = {
  getAll: (params) => api.get('/tasks', { params }),
  getStats: () => api.get('/tasks/stats'),
  create: (data) => api.post('/tasks', data),
  update: (id, data) => api.put(`/tasks/${id}`, data),
  delete: (id) => api.delete(`/tasks/${id}`),
};

// Chat endpoints
export const chatAPI = {
  getConversations: (facilityId) => api.get('/chat/conversations', { params: { facilityId } }),
  createConversation: (data) => api.post('/chat/conversations', data),
  getMessages: (conversationId) => api.get(`/chat/conversations/${conversationId}/messages`),
  sendMessage: (conversationId, message) => api.post(`/chat/conversations/${conversationId}/messages`, { message }),
  deleteConversation: (id) => api.delete(`/chat/conversations/${id}`),
  generateRenewal: (data) => api.post('/chat/generate-renewal', data),
  getModelingGuidance: (modelingRequest) => api.post('/chat/modeling-guidance', { modelingRequest }),
};

// Subscription endpoints
export const subscriptionAPI = {
  getCurrent: () => api.get('/subscriptions/current'),
  getPlans: () => api.get('/subscriptions/plans'),
  upgrade: (data) => api.post('/subscriptions/upgrade', data),
};

// Knowledge base endpoints
export const knowledgeBaseAPI = {
  getAll: () => api.get('/knowledge-base'),
  create: (data) => api.post('/knowledge-base', data),
  upload: (formData) => api.post('/knowledge-base/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  delete: (id) => api.delete(`/knowledge-base/${id}`),
};

export default api;
